/** @flow */

const allowedInsertChars = /^[0-9.\-]*$/;

function asNumberInput(target: EventTarget | null): HTMLInputElement | null {
  if (!(target instanceof HTMLInputElement)) return null;
  return target.type === "number" ? target : null;
}

function handleBeforeInput(event: Event) {
  const input = asNumberInput(event.target);
  if (!input) return;

  const data = (event: any).data;
  if (typeof data !== "string") return;
  if (allowedInsertChars.test(data)) return;

  event.preventDefault();
}

function handleBlur(event: Event) {
  const input = asNumberInput(event.target);
  if (!input) return;
  if (input.validity.badInput) input.value = "";
}

export function installNumericInputGuard() {
  document.addEventListener("beforeinput", handleBeforeInput, true);
  document.addEventListener("blur", handleBlur, true);
}
